import { ResponseError } from '@backstage/errors';

class InfracostClient {
  configApi;
  fetchApi;
  constructor(options) {
    this.configApi = options.configApi;
    this.fetchApi = options.fetchApi;
  }
  async fetch(path) {
    const baseUrl = `${this.configApi.getString("backend.baseUrl")}/api/infracost/`;
    const url = new URL(path, baseUrl);
    const response = await this.fetchApi.fetch(url.toString());
    if (!response.ok) {
      throw await ResponseError.fromResponse(response);
    }
    return response.json();
  }
  async getEstimates() {
    const response = await this.fetch("");
    return response;
  }
  async getEstimateByName(estimateName) {
    const response = await this.fetch(estimateName);
    return response;
  }
}

export { InfracostClient };
//# sourceMappingURL=InfracostClient.esm.js.map
